<template>

    <section v-if="quoteRequest && quoteRequest.company">
        <!-- Scope of works -->
        <div class="footer footer--accept" v-if="!stepReached || (acceptStatus !== 'Opened' && acceptStatus !== 'Quoting' && acceptStatus !== 'Accepted')">
            <div class="container">
                <div class="section-accept" v-if="quoteRequest && step === 1 && !reopenVisible">
                    <span v-show="!settingAcceptStatus">Are you interested?</span>
                    <span v-show="settingAcceptStatus">Please wait <button type="button"
                                                                           class="button is-loading btn-loader"></button></span>
                    <div class="has-text-centered columns">
                        <div class="column"><button type="button" @click="setAcceptStatus('yes')" class="btn-invite"
                                                            v-bind:class="{'selected': acceptStatusValid}">YES <span v-if="acceptStatusValid"
                                                                                                                     class="fa fa-check"></span>
                        </button></div>
                        <div class="column"><button type="button" @click="setAcceptStatus('later')"
                                                            class="btn-invite  btn-invite--secondary"
                                                            v-bind:class="{'selected': acceptStatus === 'Pending'}">YES, LATER <span
                                v-if="acceptStatus === 'Pending'" class="fa fa-check"></span></button></div>
                        <div class="column"><button type="button" @click="setAcceptStatus('no')" class="btn-invite  btn-invite--secondary"
                                                            v-bind:class="{'selected': acceptStatus === 'Declined'}">NO <span
                                v-if="acceptStatus === 'Declined'"
                                class="fa fa-check"></span>
                        </button></div>
                    </div>
                </div>
            </div>
        </div>

        <re-open v-show="reopenVisible && acceptStatus !== 'Accepted'"
                 :date-deadline="dateDeadline"
                 :date-submitted="dateSubmitted"
                 v-on:adjustQuote="adjustQuote"
                 :reopening="reopening"
                 :reopened-success="reopenedSuccess"
                 :reopen-error-message="reopenErrorMessage"
        ></re-open>

        <!--Fixed top right toggle menu-->
        <div v-show="statusMenu && acceptStatus !== 'Submitted'" class="section-accept  section-accept--menu">
            <p class="has-text-centered">Are you interested?</p>
            <span v-show="settingAcceptStatus"><button type="button" class="button is-loading btn-loader"
                                                       style="width: 100%; padding: 0; margin-left: 0 !important"></button></span>
            <div class="has-text-centered">
                <button type="button" @click="setAcceptStatus('yes')" class="btn-invite"
                        v-bind:class="{'selected': acceptStatusValid}">YES <span v-if="acceptStatusValid"
                                                                                 class="fa fa-check"></span>
                </button>
                <button type="button" @click="setAcceptStatus('later')" class="btn-invite  btn-invite--secondary"
                        v-bind:class="{'selected': acceptStatus === 'Pending'}">YES, LATER <span
                        v-if="acceptStatus === 'Pending'" class="fa fa-check"></span></button>
                <button type="button" @click="setAcceptStatus('no')" class="btn-invite  btn-invite--secondary"
                        v-bind:class="{'selected': acceptStatus === 'Declined'}">NO <span
                        v-if="acceptStatus === 'Declined'"
                        class="fa fa-check"></span>
                </button>
            </div>
        </div>
    </section>
</template>

<script>

import axios from 'axios'
import ReOpen from '@/components/alerts/ReOpen.vue'

export default {
  name: 'section-accept',
  components: {ReOpen},
  props: ['quoteRequest', 'dateDeadline', 'dateSubmitted', 'token', 'step', 'stepReached', 'statusMenu', 'reopenVisible'],
  data () {
    return {
      settingAcceptStatus: false,
      reopening: false,
      reopenedSuccess: null,
      reopenErrorMessage: ''
    }
  },
  methods: {
    setAcceptStatus (status) {
      this.settingAcceptStatus = true
      const AuthStr = `Bearer ${this.token}`
      axios.post(`${window.APP_CONFIG.apiServiceUrl}quoterequest/portal/respond/${status}`, null, {headers: {Authorization: AuthStr}})
        .then(response => {
          // get Data
          axios.get(`${window.APP_CONFIG.apiServiceUrl}quoterequest/portal/request`, {headers: {Authorization: AuthStr}})
            .then(response => {
              let destinationStep = (status === 'yes') ? 2 : 1
              this.$store.commit('storeData', response.data)
              this.$store.commit('updateStep', destinationStep)
              this.$store.commit('updateStepReached', destinationStep)
              this.settingAcceptStatus = false
              this.showQuoteInBX = (status === 'yes') && this.isLDFlagCRFQViaBuildxact
            })
            .catch((error) => {
              console.log('error', error)
            })
        })
    },
    adjustQuote () {
      this.reopening = true
      this.reopenedSuccess = null
      this.reopenErrorMessage = ''
      const AuthStr = `Bearer ${this.token}`
      axios.post(`${window.APP_CONFIG.apiServiceUrl}quoterequest/portal/respond/yes`, null, {headers: {Authorization: AuthStr}})
        .then(response => {
          // get Data
          axios.get(`${window.APP_CONFIG.apiServiceUrl}quoterequest/portal/request`, {headers: {Authorization: AuthStr}})
            .then(response => {
              this.$store.commit('storeData', response.data)
              this.$store.commit('updateStep', 2)
              this.$store.commit('updateReopenVisible', response.data.recipient.dateSubmitted !== null)
              this.reopening = false
              this.reopenedSuccess = null
            })
            .catch((error) => {
              console.error('post reopen request error', error)
              this.reopening = false
              this.reopenedSuccess = false // will show error
            })
        })
        .catch((error) => {
          console.error('reopen error', error)
          this.reopening = false
          this.reopenedSuccess = false
          this.reopenErrorMessage = 'This Quote Request is now closed'
        })
    }
  },
  computed: {
    acceptStatus () {
      return this.$store.state.data.recipient.quoteStatus
    },
    acceptStatusValid () {
      // Don't include opened... !
      // this.$store.state.data.recipient.quoteStatus === 'Opened'
      return ((this.$store.state.data && this.$store.state.data.recipient && (this.$store.state.data.recipient.quoteStatus === 'Quoting' || this.$store.state.data.recipient.quoteStatus === 'Submitted')) || this.stepReached > 1)
    },
    showQuoteInBX: {
      get: function () {
        if (this.$store.state) {
          return this.$store.state.showQuoteInBX
        } else { return false }
      },
      set: function (newVal) {
        this.$store.commit('updateShowQuoteInBX', newVal)
      }
    },
    isLDFlagCRFQViaBuildxact: {
      get: function () {
        if (this.$store.state) {
          return this.$store.state.data.isLDFlagCRFQViaBuildxact
        } else { return false }
      }
    }
  }
}
</script>
